module.exports = __webpack_public_path__ + "img/enemy_123_001.a84dc18c.png";